import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const SocialYoutubeIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M15.0303 12.2798L9.57328 14.8558C9.46428 14.9068 9.33328 14.8618 9.28128 14.7528C9.26728 14.7238 9.25928 14.6918 9.25928 14.6588V9.34979C9.25928 9.18879 9.43228 9.08379 9.57728 9.15679L15.0353 11.8918C15.1423 11.9458 15.1853 12.0748 15.1333 12.1818C15.1103 12.2258 15.0743 12.2588 15.0303 12.2798ZM17.8453 1.99981C20.1393 1.99981 22.0002 3.83881 22.0002 6.1068V17.8938C22.0002 20.1608 20.1403 21.9998 17.8453 21.9998H6.15429C3.8603 21.9998 2.0003 20.1608 2.0003 17.8938V6.1068C2.0003 3.83881 3.8593 2.00081 6.15429 2.00081L17.8453 1.99981ZM18 4.00001H5.99999C4.89599 4.00001 4 4.896 4 6V18C4 19.104 4.89599 20 5.99999 20H18C19.104 20 20 19.104 20 18V6C20 4.896 19.104 4.00001 18 4.00001Z"
            fill="#222"
          />
        </svg>
      </IconWrapper>
    )
  },
)
